export const ADD_SEQUENCE = 'ADD_SEQUENCE';
export const UPDATE_CHAPTER = 'UPDATE_CHAPTER';
export const UPDATE_STEP = 'UPDATE_STEP';
export const UPDATE_STEP_EDIT = 'UPDATE_STEP_EDIT';
export const ADD_STEP = 'ADD_STEP';
export const UPDATE_ACTION = 'UPDATE_ACTION';
export const RESET_STAGE = 'RESET_STAGE';
export const UPDATE_SEQUENCE = 'UPDATE_SEQUENCE';
export const ADD_ACTION_TO_STEP = 'ADD_ACTION_TO_STEP';
export const UPDATE_ACTION_EDIT = 'UPDATE_ACTION_EDIT';
export const ADD_ACTION = 'ADD_ACTION';



//Creators : Léo Yang @3DDGAMES -- Under license
